import PropTypes from 'prop-types';
import React from 'react';

const SmsPostviewPropType = {
  content: PropTypes.string.isRequired,
};

export default SmsPostviewPropType;
